<template>
    <div :class="style.selectSimple">
        <select @focus="$emit('focus')" @blur="$emit('blur')" @input="$emit('select', $event.target.value)" v-model="model">
            <option v-for="item in list" :value="item.id" :key="item.id">{{ item.value }}</option>
        </select>
    </div>
</template>

<script>
    import Vue from 'vue'
    import style from './style.module.scss'

    export default Vue.extend({
        name: 'select-simple',
        components: {

        },
        props: {
            list: Array,
            value: [ String, Number ],
            setDefault: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                style: style,
                isDefaultSetted: false
            }
        },
        computed: {
            model: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('select', value);
                }
                
            }
        },
        watch: {
            "list"() {
                if (this.setDefault && !this.isDefaultSetted){
                    this.$emit('select', "" + this.list[0].id);
                    this.isDefaultSetted = true;
                }   
            }
        }
    })
</script>